"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Service
 * Provides OIDC and Security endpoints as well as CRUD operations for SAVE and E-Verify Users and Points of Contact.
 *
 * The version of the OpenAPI document: 3.0.32
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EverifyUserRoleToJSON = exports.EverifyUserRoleFromJSONTyped = exports.EverifyUserRoleFromJSON = exports.EverifyUserRole = void 0;
/**
 * see https://maestro.dhs.gov/confluence/display/AR/Users+and+Roles for capabilities
 * @export
 * @enum {string}
 */
var EverifyUserRole;
(function (EverifyUserRole) {
    EverifyUserRole["GENERAL"] = "GENERAL";
    EverifyUserRole["PROGRAMADMIN"] = "PROGRAM_ADMIN";
    EverifyUserRole["CORPORATEADMIN"] = "CORPORATE_ADMIN";
    EverifyUserRole["WEBSERVICE"] = "WEB_SERVICE";
    EverifyUserRole["ENROLLMENT"] = "ENROLLMENT";
    EverifyUserRole["UNKNOWN"] = "UNKNOWN";
})(EverifyUserRole = exports.EverifyUserRole || (exports.EverifyUserRole = {}));
function EverifyUserRoleFromJSON(json) {
    return EverifyUserRoleFromJSONTyped(json, false);
}
exports.EverifyUserRoleFromJSON = EverifyUserRoleFromJSON;
function EverifyUserRoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.EverifyUserRoleFromJSONTyped = EverifyUserRoleFromJSONTyped;
function EverifyUserRoleToJSON(value) {
    return value;
}
exports.EverifyUserRoleToJSON = EverifyUserRoleToJSON;
